const FeatureGrid = () => {
  const features = [
    {
      icon: 'ri-24-hours-line',
      title: '24/7 Call Answering',
      description: 'Never miss a call, day or night, weekends or holidays',
      color: 'pink'
    },
    {
      icon: 'ri-message-2-line',
      title: 'Missed-Call Text Back',
      description: 'Automatically texts customers who couldn\'t reach you',
      color: 'purple'
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Appointment Scheduling',
      description: 'Books appointments directly to your calendar',
      color: 'blue'
    },
    {
      icon: 'ri-mic-line',
      title: 'AI Voice Agent',
      description: 'Natural-sounding conversations with customers',
      color: 'green'
    },
    {
      icon: 'ri-user-add-line',
      title: 'Lead Capture',
      description: 'Collects and qualifies leads automatically',
      color: 'orange'
    },
    {
      icon: 'ri-database-2-line',
      title: 'CRM Sync',
      description: 'Integrates with your existing CRM system',
      color: 'cyan'
    },
    {
      icon: 'ri-star-smile-line',
      title: 'Review Automation',
      description: 'Sends review requests and responds automatically',
      color: 'yellow'
    },
    {
      icon: 'ri-global-line',
      title: 'Multi-Language Support',
      description: 'Communicates in multiple languages',
      color: 'indigo'
    },
    {
      icon: 'ri-record-circle-line',
      title: 'Call Recording',
      description: 'Records and transcribes every conversation',
      color: 'red'
    },
    {
      icon: 'ri-team-line',
      title: 'Team Handoff',
      description: 'Transfers calls to your team when needed',
      color: 'teal'
    }
  ];

  const colorClasses: Record<string, { bg: string; icon: string }> = {
    pink: { bg: 'bg-pink-50', icon: 'text-pink-600' },
    purple: { bg: 'bg-purple-50', icon: 'text-purple-600' },
    blue: { bg: 'bg-blue-50', icon: 'text-blue-600' },
    green: { bg: 'bg-green-50', icon: 'text-green-600' },
    orange: { bg: 'bg-orange-50', icon: 'text-orange-600' },
    cyan: { bg: 'bg-cyan-50', icon: 'text-cyan-600' },
    yellow: { bg: 'bg-yellow-50', icon: 'text-yellow-600' },
    indigo: { bg: 'bg-indigo-50', icon: 'text-indigo-600' },
    red: { bg: 'bg-red-50', icon: 'text-red-600' },
    teal: { bg: 'bg-teal-50', icon: 'text-teal-600' }
  };

  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Everything You Need in One Platform
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ReceptionGenie comes packed with powerful features to help you manage customer communications effortlessly
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const colors = colorClasses[feature.color];
            return (
              <div 
                key={index}
                className="bg-white border-2 border-gray-100 rounded-2xl p-6 hover:border-pink-200 hover:shadow-lg transition-all duration-300"
              >
                <div className={`w-14 h-14 ${colors.bg} rounded-xl flex items-center justify-center mb-4`}>
                  <i className={`${feature.icon} ${colors.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            );
          })}
        </div>
        
        <div className="text-center mt-12">
          <a 
            href="tel:+18886009252"
            className="inline-block whitespace-nowrap px-8 py-4 bg-pink-500 hover:bg-pink-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
          >
            Call the AI Demo
          </a>
        </div>
      </div>
    </section>
  );
};

export default FeatureGrid;